import React, { PropsWithChildren } from 'react';
import HeaderMenu from 'layout/HeaderMenu';

export default function HeaderMenuLayout({ children }: PropsWithChildren<{}>) {
    return (
        <div className="flex flex-col h-screen">
            <HeaderMenu />
            {children}
        </div>
    );
}